import { IFilter } from '../store/filter/types';

export const cloneFilterObject = (
    filter: IFilter
): IFilter => {
    return JSON.parse(JSON.stringify(filter));
};
